import styled from 'styled-components';

const ProgressContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	padding: 1rem;
	background: rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.1);
	border-radius: 0.375rem;
`;

const StageIndicator = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

const StageDot = styled.div`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background: ${({ $active, theme }) =>
		$active ? theme.colors.green : 'rgba(255, 255, 255, 0.3)'};
	transition: all 0.3s ease;
`;

const StageLabel = styled.span`
	font-size: 0.875rem;
	color: ${({ $active }) => ($active ? '#ffffff' : 'rgba(255, 255, 255, 0.6)')};
	font-weight: ${({ $active }) => ($active ? '600' : '400')};
`;

const Separator = styled.div`
	width: 30px;
	height: 2px;
	background: rgba(255, 255, 255, 0.2);
`;

const StageProgress = ({ current, total }) => {
	const stages = [
		{ number: 3, label: 'Select Video' },
		{ number: 4, label: 'Configure' },
		{ number: 5, label: 'Upload' },
		{ number: 6, label: 'Complete' },
	];

	return (
		<ProgressContainer>
			{stages.map((stage, index) => (
				<StageIndicator key={stage.number}>
					<StageDot $active={current >= stage.number} />
					<StageLabel $active={current === stage.number}>{stage.label}</StageLabel>
					{index < stages.length - 1 && <Separator />}
				</StageIndicator>
			))}
		</ProgressContainer>
	);
};

export default StageProgress;
